<template>
	<div>
		<i class="fa font_lg" :class="icon + ' ' + color" aria-hidden="true"></i>
	</div>
</template>

<script>
import enumStatus from "@/common/enum";

export default {
	data() {
		return {
			icon: "",
			color: "base_color"
		};
	},
	mounted() {
		let {requestObligorConfirmation, confirmLevel} = this.params.data;
		if (requestObligorConfirmation) {
			enumStatus.IPUList.forEach(item => {
				if (item.confirmLevel === confirmLevel) {
					this.icon = item.icon;
					this.color = item.color;
				}
			});
		}
	}
};
</script>
